import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import ProductCreatePage from './product-create'
import UpdateProductPage from './product-update'
import { ProductListPage } from './products-list'

const productRoutes: Route[] = [
  {
    path: Paths.PRODUCTS_LIST_PAGE,
    element: <ProductListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PRODUCT_CREATE_PAGE,
    roles: [RoleEnum.ADMIN],
    element: <ProductCreatePage />
  },
  {
    path: Paths.PRODUCT_UPDATE_PAGE,
    roles: [RoleEnum.ADMIN],
    element: <UpdateProductPage />
  }
]

export default productRoutes
